import { render, staticRenderFns } from "./ResourceCalendar.vue?vue&type=template&id=6c04ed05"
import script from "./ResourceCalendar.vue?vue&type=script&lang=js"
export * from "./ResourceCalendar.vue?vue&type=script&lang=js"
import style0 from "./ResourceCalendar.vue?vue&type=style&index=0&id=6c04ed05&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports